import React, { useEffect, useState } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import api from "../../api/axios";
import { ErroContainer } from "../../styles/GlobalStyles";

export const CreateNewAccountModal = ({
  open,
  columns,
  onClose,
  onSubmit,
  professionalData,
  professional = null,
}) => {
  const [values, setValues] = useState(() =>
    columns.reduce((acc, column) => {
      acc[column.accessorKey ?? ""] = "";
      return acc;
    }, {}),
  );

  const [error, setError] = useState("");

  const handleSubmit = async () => {
    setError("");
    const isFormValid =
      values.professional && values.registration && values.start_date;

    if (!isFormValid) {
      setError("Por favor, preencha todos os campos!");
      return;
    }

    const registrationExists = await api.post(
      "/cooperative/check-registration",
      { registration: values.registration },
    );

    if (registrationExists.data.result) {
      setError("Este número de matrícula já existe");
      return;
    }

    onSubmit(values);
    setValues({});
    onClose();
  };

  const handleClose = () => {
    setValues({});
    setError("");
    onClose();
  };

  useEffect(() => {
    if (professional) setValues({ ...values, professional });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [professional]);

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth={false}
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: "900px",
          minWidth: "300px",
        },
      }}
    >
      <DialogTitle textAlign="center">Novo Cooperado</DialogTitle>
      <DialogContent>
        <form onSubmit={(e) => e.preventDefault()}>
          <Stack
            sx={{
              width: "100%",
              padding: "10px 0",
              minWidth: "300px",
              gap: "1.5rem",
            }}
          >
            {columns.map((column) =>
              column.header === "ID" || column.header === "Ocorrências" ? (
                <></>
              ) : column.header === "Profissional" ? (
                <FormControl>
                  <InputLabel id={column.accessorKey}>Profissional</InputLabel>
                  <Select
                    labelId={column.accessorKey}
                    key={column.accessorKey}
                    label={column.header}
                    name={column.id}
                    id={column.accessorKey}
                    defaultValue={professional}
                    onChange={(e) => {
                      setValues({ ...values, [e.target.name]: e.target.value });
                      setError("");
                    }}
                  >
                    {Array.isArray(professionalData) ? (
                      professionalData.map((professional) => (
                        <MenuItem
                          value={professional._id}
                        >{`${professional.name} (${professional.cpf})`}</MenuItem>
                      ))
                    ) : (
                      <></>
                    )}
                  </Select>
                </FormControl>
              ) : column.header === "Início de vigência" ||
                column.header === "Fim de vigência" ? (
                <DatePicker
                  key={column.accessorKey}
                  label={column.header}
                  name={column.id}
                  onChange={(value) => {
                    setValues({
                      ...values,
                      [column.id]: new Date(value),
                    });
                    setError("");
                  }}
                />
              ) : (
                <TextField
                  key={column.accessorKey}
                  label={column.header}
                  name={column.accessorKey}
                  onChange={(e) => {
                    setValues({ ...values, [e.target.name]: e.target.value });
                    setError("");
                  }}
                />
              ),
            )}
          </Stack>
        </form>
        <ErroContainer>{error ? error : ""}</ErroContainer>
      </DialogContent>
      <DialogActions sx={{ p: "1.25rem" }}>
        <Button sx={{ color: "#104467" }} onClick={handleClose}>
          Cancelar
        </Button>
        <Button
          sx={{ backgroundColor: "#104467" }}
          onClick={handleSubmit}
          variant="contained"
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
